import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { BASE_URL } from "../host";
import { GET_PROFILE, LOGIN, REGISTER } from "./Auth";


function useAuth() {
  const dispatch = useDispatch();
  const { auth } = useSelector(state => state)
  const register = async ({ userid, username, email, password, level }) => {

    try {
      const res = await axios.post(BASE_URL + 'auth/register', {
        userid,
        username,
        email,
        password,
        level
      })
      console.log(res)
      dispatch({
        type: REGISTER,
        token: res.data,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const login = async ({ userid, password }) => {
    try {
      const res = await axios.post(BASE_URL + 'auth/login ', {
        userid,
        password,
      })
      const response = JSON.parse(res.data.data);
      //  console.log(response, response.userid)
      sessionStorage.setItem('userid', response.userid)
      // sessionStorage.setItem('username', response.username)
      // sessionStorage.setItem('email', response.email)
      // sessionStorage.setItem('password', response.password)
      // sessionStorage.setItem('level', response.level)
      console.log(sessionStorage.getItem('userid'));
      dispatch({
        type: LOGIN,
        user: response,
      })
    } catch (error) {
      window.alert('아이디나 비밀번호가 잘못되었습니다.')
      console.log(error)
    }
  }
  const getProfile = async userid => {
    console.log('dkdkdk');
    try {
      const res = await axios.post(BASE_URL + 'auth/profile', {
        userid
      })
      const response = JSON.parse(res.data.data);

      dispatch({
        type: GET_PROFILE,
        user: response
      })
    } catch (error) {
      console.log(error);
    }

  }

  return {
    auth,
    register,
    getProfile,
    login,
  }


}
export default useAuth;